define('views/modules/member/group/lists/group-list',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/member/group',
    // views
    'views/modules/member/group/lists/group-list-item',
    // templates
    'text!templates/modules/member/group/lists/group-list.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // models
    MGroup,
    // views
    VGroupItem,
    // templates
    TGroupList

) {

    var VGroupList = Backbone.View.extend({

        template: TGroupList,
        // events: {
        // },
        regions: {
            groups: ".group-list",
        },

        initialize: function(opt) {
            opt = opt || {};
            this.options = _.extend({
                title: "Groups",
                icon: "sl-icon-layers"
            }, opt);

            // for epoxy bindings
            this.model = new Backbone.Model({
                collection: this.collection
            });
            // listeners
            this.listenTo(this.collection, {
                'group:click': this.onGroupClick,
                'add': this.addGroup,
                'reset': this.render
            });
            this.listenTo(this, { 'click': this.onGroupClick });
            this.listenTo(this, { 'group:click': this.onGroupClick });
            this.listenTo(this.childViews, { 'group:click': this.onGroupClick });

            this.listenTo(this.collection, { 'click': this.onGroupClick });
        },


        render: function() {

            var html = Mustache.to_html(this.template, Mustache.getContext(this.options));
            this.$el.empty().html(html);

            this.collection.fetch({ async: false });
            this.generateZones();

            this.addAllGroups();

            return this;
        },

        addAllGroups: function() {
            var delay = 50;
            var count = 1;

            this.collection.each(function(group) {
                var nextDelay = delay * count;
                this.addgroup(group, nextDelay);
                count++;
            }, this);
        },

        addgroup: function(model, delay) {
            if (!model.isTopLevelFirstGroup()) {
                var view = new VGroupItem({
                    model: model
                });
                this.childViews.push(view);
                this.zone.$groups.append(view.render().el);

                view.$el.css('opacity', '0');

                _.delay(function() {
                    view.$el.animate({
                        opacity: 1
                    }, 250);
                }, delay);
          }

          model.get("subgroups").each(function(group) {
              this.addgroup(group, delay);
          }, this);
        },

        onGroupClicked: function(Model) {
            this.model.trigger('group:click', this.collection);
        },
    });

    return VGroupList;

});

